import { render } from "./CadastraCorretores.vue?vue&type=template&id=317294f7"
import script from "./CadastraCorretores.vue?vue&type=script&lang=js"
export * from "./CadastraCorretores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__